import { darkThemeVariables } from './variables/dark';
import { lightThemeVariables } from './variables/light';
import { retroThemeVariables } from './variables/retro';
import { getThemeParam } from '../utils/urlParams';

const themeVariables = {
    dark: darkThemeVariables,
    light: lightThemeVariables,
    retro: retroThemeVariables
} as const;

export type ThemeName = keyof typeof themeVariables;


const getUtmTheme = (): ThemeName => {
    const utmTheme = getThemeParam() as ThemeName;

    return themeVariables[utmTheme] ? utmTheme : 'dark';
};

export const getCurrentThemeVariables = () => {
    const themeName = getUtmTheme();
    return themeVariables[themeName];
};


export const initializeCSSVariables = () => {
    if (typeof window === 'undefined') return;

    const themeName = getUtmTheme();
    const variables = themeVariables[themeName];
    const root = document.documentElement;

    Object.entries(variables).forEach(([variable, value]) => {
        root.style.setProperty(variable, value);
    });


    localStorage.setItem('MemoryOSthm', themeName);

    console.log(`Applied theme: ${themeName}`);
    return themeName;
};

export const changeTheme = (themeName: ThemeName) => {
    const variables = themeVariables[themeName];
    const root = document.documentElement;

    Object.entries(variables).forEach(([variable, value]) => {
        root.style.setProperty(variable, value);
    });

    localStorage.setItem('MemoryOSthm', themeName);
};

interface UseCSSVariablesReturn {
    currentTheme: ThemeName;
    applyTheme: (themeName?: ThemeName) => void;
    getCurrentThemeVariables: () => typeof themeVariables[ThemeName];
    availableThemes: ThemeName[];
}

export const useCSSVariables = (): UseCSSVariablesReturn => {
    const currentTheme = getUtmTheme();

    const applyTheme = (themeName?: ThemeName) => {
        if (themeName) {
            changeTheme(themeName);
        } else {
            initializeCSSVariables();
        }
    };

    return {
        currentTheme,
        applyTheme,
        getCurrentThemeVariables,
        availableThemes: Object.keys(themeVariables) as ThemeName[]
    };
};
